import { Component, OnInit, Input } from '@angular/core';
import { TaskDetailsObject } from 'src/app/models/tasks/tasks-details/task-details.model';

@Component({
  selector: 'app-properties-content',
  templateUrl: './properties-content.component.html',
  styleUrls: ['./properties-content.component.css']
})
export class PropertiesContentComponent implements OnInit {

  @Input() groupHeaderTitle: string;
  @Input() taskDetails: TaskDetailsObject;

  constructor() { }

  ngOnInit() {

  }

}
